// core
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

@Pipe({
  name: 'raptorCurrency'
})
export class RaptorCurrencyPipe implements PipeTransform {
  currency!: string;

  constructor(private partnerBrandService: PartnerBrandService) {
    this.currency = this.partnerBrandService.getCurrencySymbol();
  }

  transform(question: any, value: string | number, ...args: unknown[]): unknown {
    let formattedValue;
    let currencyPipe = new CurrencyPipe('en');
    
    if ((question.type === 'currency' || question.settings?.format === 'currency') && value) {
      let decimalPlaces = (question.settings && question.settings.disable_decimal === true) ? 0 : 2;
      value = typeof value === 'string' ? value.replace(/[^0-9.]/g, '').replace(/^0+/, '') : value;
      formattedValue = currencyPipe.transform(value, '', this.currency, '1.' + decimalPlaces + '-' + decimalPlaces);
    } else {
      formattedValue = value;
    }
    return formattedValue;
  }
}
